import React from "react";
import { Link } from "react-router-dom";

// Twilio A2P 10DLC requires this exact disclosure beside EACH SMS consent
// checkbox, not once for the group — so it is rendered per checkbox.
const SmsDisclosure = () => (
  <small className="sms_disclosure">
    Message frequency varies. Message and data rates may apply. Reply STOP to
    unsubscribe. Reply HELP for help. View our{" "}
    <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </Link>{" "}
    and{" "}
    <Link to="/terms-conditions" target="_blank" rel="noopener noreferrer">
      Terms of Service
    </Link>
    .
  </small>
);

// SMS/email consent — kept directly beneath the phone field for A2P 10DLC.
// All three are optional and unchecked by default; none may block signup.
// Shared by the signup form and the event signup page so the legal copy
// lives in one place.
const SmsConsentFields = ({ register, defaultValues }) => (
  <div className="blk_form sms_consent_blk">
    <div className="small_txt agree_smll">
      <div className="txtGrp flex">
        <div className="lblBtn flex accept_blk">
          <input
            type="checkbox"
            id="transactional_sms_consent"
            defaultChecked={!!defaultValues?.transactional_sms_consent}
            {...register("transactional_sms_consent")}
          />
          <div className="consent_txt">
            <label htmlFor="transactional_sms_consent">
              I agree to receive transactional SMS messages including
              appointment reminders, account notifications, verification
              codes, and other service-related communications.
            </label>
            <SmsDisclosure />
          </div>
        </div>
      </div>
      <div className="txtGrp flex">
        <div className="lblBtn flex accept_blk">
          <input
            type="checkbox"
            id="marketing_sms_consent"
            defaultChecked={!!defaultValues?.marketing_sms_consent}
            {...register("marketing_sms_consent")}
          />
          <div className="consent_txt">
            <label htmlFor="marketing_sms_consent">
              I agree to receive promotional and marketing SMS messages about
              products, services, and special offers.
            </label>
            <SmsDisclosure />
          </div>
        </div>
      </div>
      <div className="txtGrp flex">
        <div className="lblBtn flex accept_blk">
          <input
            type="checkbox"
            id="property_recommendation_updates"
            defaultChecked={!!defaultValues?.property_recommendation_updates}
            {...register("property_recommendation_updates")}
          />
          <label htmlFor="property_recommendation_updates">
            I agree to receive marketing emails and property recommendation
            updates from Rhino Recon.
          </label>
        </div>
      </div>
    </div>
  </div>
);

export default SmsConsentFields;
